export default "__VITE_ASSET__DD03xoOQ__"